import { ClerkProvider } from "@clerk/clerk-react";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";

// Get Clerk publishable key from environment variables or use fallback for development
const PUBLISHABLE_KEY =
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ||
  (process.env.NODE_ENV === "development"
    ? "pk_test_cmVzb2x2ZWQtYm9uZWZpc2gtNzMuY2xlcmsuYWNjb3VudHMuZGV2JA"
    : null);

// Warn if using fallback keys
if (
  !import.meta.env.VITE_CLERK_PUBLISHABLE_KEY &&
  process.env.NODE_ENV === "development"
) {
  console.warn(
    "Using fallback Clerk publishable key. For production, set VITE_CLERK_PUBLISHABLE_KEY environment variable."
  );
} else if (!PUBLISHABLE_KEY) {
  console.error(
    "Missing Clerk publishable key. Application may not function correctly."
  );
}

// Log the key being used (partial for security)
if (PUBLISHABLE_KEY) {
  console.log(
    "Initializing Clerk with key:",
    PUBLISHABLE_KEY.substring(0, 10) + "..."
  );
} else {
  console.log("No Clerk publishable key available");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignInUrl="/"
      afterSignUpUrl="/"
      appearance={{
        baseTheme: "dark",
        elements: {
          formButtonPrimary: "bg-[#4db1e0] hover:bg-[#3da0cf]",
          card: "bg-[#1a1e21] text-white",
          headerTitle: "text-[#4db1e0]",
          headerSubtitle: "text-gray-300",
          socialButtonsIconButton:
            "border-gray-600 text-white hover:bg-[#262b30]",
          formFieldLabel: "text-gray-300",
          formFieldInput: "bg-[#262b30] border-gray-600 text-white",
          footerActionLink: "text-[#4db1e0] hover:text-[#5dc9fc]",
        },
      }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
